import store from '../store';
import axios from 'axios';
import router from "../router";

export default {
  name: 'groupsPlaceApi',

  checkMaintenance() {
    if (store.state.settings && store.state.settings.maintenanceMode) {
      window.location = "/maintenance"
      return true
    }
    return false
  },

  genHeader() {
    //we might get here before the setters are done!
    let apiKey = localStorage.getItem("apiKey")
    let secret = localStorage.getItem("secret")
    return {
      headers: {'ApiKey': apiKey, 'SecretKey': secret, 'ui_version': process.env.BUILD_VERSION},
      withCredentials: true
    };
  },
  async logout(key, secret) {  //we could already be logged out locally, so we need the key!
    if (!key) return
    if (key == "") return
    let ret;
    await axios.get(process.env.BACKEND_URL + "/api/v1/user/logout", {
      headers: {
        'ApiKey': key,
        'SecretKey': secret,
        'ui_version': process.env.BUILD_VERSION
      }, withCredentials: true
    }).then(
      response => {
        ret = response;
      },
      error => {
        ret = error.response;
      }
    );
    return ret;
  },
  async groupBasics(vanityPath, mode) {
    if (this.checkMaintenance()) return
    let current = store.getters.currentGroup;
    if (!current || current.vanityPath != vanityPath) {
      await axios.get(process.env.BACKEND_URL + "/api/v1/group/info/" + vanityPath + "?mode=" + mode, this.genHeader()).then(
        response => {
          store.dispatch("setCurrentGroup", response.data);
        },
        error => {
          store.dispatch("setCurrentGroup", null);
        }
      );
    }
  },
  async waitGet(path) {
    let ret;
    await axios.get(process.env.BACKEND_URL + "/api/v1" + path, this.genHeader()).then(
      response => {
        ret = response;
      },
      error => {
        if (error.response.status == 401) {
          store.dispatch("logout");
          ret = error.response;
        } else ret = error.response;
      }
    );
    return ret;
  },
  get(path) {
    if (path != "/public/settings" && this.checkMaintenance()) return
    return axios.get(process.env.BACKEND_URL + "/api/v1" + path, this.genHeader());
  },
  getExternalBlob(path) {
    if (this.checkMaintenance()) return
    return axios.get(path);
  },
  getBlob(path) {
    if (this.checkMaintenance()) return
    let h = this.genHeader();
    h.responseType = "blob";
    return axios.get(process.env.BACKEND_URL + "/api/v1" + path, h);
  },
  postBlob(path, data) {
    if (this.checkMaintenance()) return
    let h = this.genHeader();
    h.responseType = "blob";
    return axios.post(process.env.BACKEND_URL + "/api/v1" + path, data, h);
  },
  reloadUser() {
    axios.get(process.env.BACKEND_URL + "/api/v1/user/details", this.genHeader()).then(
      (details) => {
        store.dispatch("setUserDetails", details.data);
      },
      (error) => {
        console.log("Error getting user details again.");
      });

  },
  post(path, data) {
    if (this.checkMaintenance()) return
    return axios.post(process.env.BACKEND_URL + "/api/v1" + path, data, this.genHeader());
  },
  put(path, data) {
    if (this.checkMaintenance()) return
    return axios.put(process.env.BACKEND_URL + "/api/v1" + path, data, this.genHeader());
  },
  postImage(path, file) {
    if (this.checkMaintenance()) return
    return this.postFile(path, file);
  },
  postFile(path, file) {
    if (this.checkMaintenance()) return
    let formData = new FormData();
    formData.append('file', file);
    formData.append('fileName', file.name);
    let headers = this.genHeader;
    headers['Content-Type'] = 'multipart/form-data';
    return axios.post(process.env.BACKEND_URL + "/api/v1" + path, formData, this.genHeader());
  },
  async getGroupFileLink(fileId, accessCode) {
    let downloadInfo
    await axios.get(process.env.BACKEND_URL + `/api/v1/groupFile/getDownloadLink/${fileId}?accessCode=${accessCode}`, this.genHeader()).then(
      response => {
        downloadInfo = response.data
      });
    return downloadInfo
  },

  async generalUploadImage(folder, group, file) {
    let ret = { s3Response: null, message: "", success: true, image: null}
    let forUser = true
    if (group || folder) forUser = false
    let payload = {isUrlRequest: true, forUser: forUser, folder: folder, group: group, filename: file.name, size: file.size, type: file.type}
    await this.post("/image/create",  payload).then(
      (results) => {
        ret.uploadRequest = results.data
      },
      (error) => {
        ret.success = false
        ret.message = error.response.data
      })

    if (! ret.success) return ret

    const response = await fetch(ret.uploadRequest.url, {
      method: 'PUT',
      body: file,
      headers: {
        'Content-Type': file.type
      },
    })
    ret.s3Response = response
    if (!response.ok) {
      ret.message = await response.text()
      ret.success = false
    }
    payload = {isUrlRequest: false, folder: folder, group: group, filename: file.name,
      size: file.size, type: file.type, uploadRequestId: ret.uploadRequest.id}
    await this.post("/image/create",  payload).then(
      (results) => {
        ret.image = results.data.image
      },
      (error) => {
        ret.success = false
        ret.message = error.response.data
      })

    return ret
  },

  async groupUploadImage(groupId, file) {
    let ret = { uploadRequest: null, s3Response: null, message: "", success: true}

    let payload = {filename: file.name, size: file.size, type: file.type}
    await this.post("/group/imageUploadRequest/" + groupId, payload).then(
      (results) => {
        ret.uploadRequest = results.data
      },
      (error) => {
        ret.success = false
        ret.message = error.response.data
      })

    if (! ret.success) return ret

    const response = await fetch(ret.uploadRequest.url, {
      method: 'PUT',
      body: file,
      headers: {
        'Content-Type': file.type
      },
    })
    ret.s3Response = response
    if (!response.ok) {
      ret.message = await response.text()
      ret.success = false
    }
    return ret

  },

  delete(path) {
    if (this.checkMaintenance()) return
    return axios.delete(process.env.BACKEND_URL + "/api/v1" + path, this.genHeader());
  },
  async getUserDetails() {
    await axios.get(process.env.BACKEND_URL + "/api/v1/user/details", this.genHeader()).then(
      response => {
        store.dispatch("setUserDetails", response.data);
      },
      error => {
        if (error.response.status == 403 && document.location.href.indexOf("/login/oauth2") < 0) {  //Don't log out if cognito login is in process
          store.dispatch("loggedIn", false)
          this.logout();
          store.dispatch("logout")
        }
      }
    );
  },
  async completeLogin(auth, secret, isNewUser) {
    console.log("Completing login.")
    localStorage.setItem("apiKey", auth)
    localStorage.setItem("secret", secret)
    await store.dispatch("setApiKey", auth)
    await store.dispatch("setSecret", secret)
    await store.dispatch("setLoggedIn", true)
    await this.getUserDetails()
    let redirect = localStorage.getItem("redirectOnLogin")
    if (redirect) {
      localStorage.removeItem("redirectOnLogin")
      router.push(redirect)
    } else if (isNewUser) router.push("/new-user")
    else router.push("/")
  },
  trackGroupVisit(vanityPath) {
    if (this.checkMaintenance()) return
    this.post("/member/trackVisit/" + vanityPath, {}).then(
      () => {

      },
      error => {
        console.log("Got error tracking last visit.", error)
      }
    );
  },
  isStandalone() {
    if ('standalone' in window.navigator) {
      return window.navigator.standalone;
    } else {
      // Check for other indicators
      if (window.matchMedia('(display-mode: standalone)').matches) {
        return true;
      } else {
        return false;
      }
    }
  }

};
